import { render, staticRenderFns } from "./replaced_components.vue?vue&type=template&id=6e67fb1f&lang=pug&"
import script from "./replaced_components.vue?vue&type=script&lang=js&"
export * from "./replaced_components.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports